import React from 'react';
import {
  Route, Switch,
} from 'react-router-dom';
import AuthorizationPage from '../../pages/authorization';
import ProtectedRoute from '../../components/ProtectedRoute';

function SignatureRoutes() {
  return (
    <Route
      render={
        ({ location }) => (
          <Switch location={location}>
            <ProtectedRoute exact path="/authorization" component={AuthorizationPage} />
          </Switch>
        )
}
    />
  );
}

export default SignatureRoutes;
